// extracted by mini-css-extract-plugin
export default {"content":"About_content__3Lwhz"};